AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Views", "Index");

AoPS.Ebooks.Views.Index = (function (EbkVIndex) {
	// Dependencies
	var compileTemplate = AoPS.View.compileTemplate;
	var Modal = AoPS.Ui.Modal;
	var EbkVBase = AoPS.Ebooks.Views.Base;
	var EbkVSearch = AoPS.Ebooks.Views.Search;
	var EbkVToc = AoPS.Ebooks.Views.Toc;

	EbkVIndex.Intro = EbkVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("ebk-tpl-index-intro");

			this.render();
		},

		postRender: function () {
			var tpl_context = {};

			var intro_html = compileTemplate("#ebk-tpl-store-intro")(tpl_context);
			this.$(".ebk-landing-top-text").html(intro_html);

			// Tab functionality
			// Based on /m/store/views/default/online.phtml

			var showTab = _.bind(function (html, evt) {
				this.$(".ebk--tab").removeClass("ebk--active");
				$(evt.currentTarget).addClass("ebk--active");
				this.$(".ebk--tab-contents").html(html);
			}, this);

			var how_it_works_html = compileTemplate("#ebk-tpl-store-how-it-works")(
				tpl_context
			);
			this.$(".ebk-landing-tab-how-it-works").on(
				"click",
				_.partial(showTab, how_it_works_html)
			);
			this.$(".ebk--tab-contents").html(how_it_works_html);

			var titles_html = compileTemplate("#ebk-tpl-store-titles")(tpl_context);
			this.$(".ebk-landing-tab-titles").on(
				"click",
				_.partial(showTab, titles_html)
			);

			var faq_html = compileTemplate("#ebk-tpl-store-faq")(tpl_context);
			this.$(".ebk-landing-tab-faq").on("click", _.partial(showTab, faq_html));
		},
	});

	EbkVIndex.Main = EbkVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("ebk-tpl-index");

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.model.getAccessibleBooks().each(function (book) {
					var view_obj = new EbkVIndex.BookListItem({model: book});
					this.addSubviewToLocation(view_obj, "@book");
				}, this);
				this.render();
				AoPS.fixSidebarAnimatedOnceOnElement(3000, "ebk-loc-index");
				$(window).on("resize", function () {
					AoPS.fixSidebarAnimatedOnceOnElement(1, "ebk-loc-index");
				});
			}, this);

			this.renderLoading();
		},

		getContext: function () {
			return {
				has_books: !!this.model.getAccessibleBooks().length,
				is_admin: !!this.model.get("is_admin"),
			};
		},
	});

	EbkVIndex.BookListItem = EbkVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("ebk-tpl-index-book-item");

			this.renderLoading(null);

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.createHeaderButtons();
				this.createChapterList();
				this.createTocBar();
				this.render();
			}, this);
		},

		events: {
			"click .ebk--cancel": "onCancelPurchase",
			"click .ebk--reset": "onResetBook",
		},

		getContext: function () {
			var model = this.model;
			return {
				store_sku: model.get("store_sku"),
				title: model.get("title"),
				by: model.getByLine(),
				cover_url: model.getCoverUrl(),
				can_cancel: model.get("can_cancel"),
			};
		},

		postRender: function () {
			var last_section_id;
			var last_section;
			if (this.toc_bar) {
				last_section_id = this.model.get("last_viewed_section_id");
				last_section = this.model.get("sections").get(last_section_id);
				this.toc_bar.setCurrentSection(last_section);
			}
		},

		createChapterList: function () {
			var break_index = Math.ceil(this.model.get("chapters").length / 2);
			this.clearLocation("@chapter_left");
			this.clearLocation("@chapter_right");
			this.model.get("chapters").each(function (chapter, i) {
				var view_obj = new EbkVIndex.BookChapter({model: chapter});
				var view_location =
					i < break_index ? "@chapter_left" : "@chapter_right";
				this.addSubviewToLocation(view_obj, view_location);
			}, this);
		},

		createTocBar: function () {
			this.clearLocation("@toc_bar");
			this.toc_bar = new EbkVToc.Bar({
				model: this.model,
				horiz: true,
				should_fill_div: true,
			});
			this.addSubviewToLocation(this.toc_bar, "@toc_bar");
		},

		createHeaderButtons: function () {
			this.clearLocation("@button_header");
			this.addSubviewToLocation(
				new EbkVSearch.SearchInput({
					model: this.model,
				}),
				"@button_header"
			);
		},

		onCancelPurchase: function () {
			var confirmTpl = compileTemplate("#ebk-cms-cancel-confirm");
			var doneTpl = compileTemplate("#ebk-cms-cancel-done");
			var model = this.model;
			var context = {
				title: this.model.get("title"),
			};

			function onConfirmCancel(reason) {
				model.cancelPurchase(reason, function (ok, data) {
					if (!ok) {
						EbkVBase.showModalError(
							"An error occurred when cancelling your purchase.",
							data
						);
					} else {
						Modal.showAlert(doneTpl(context), {
							onClose: function () {
								window.location.reload();
							},
						});
					}
				});
			}

			Modal.showConfirm(
				confirmTpl(context),
				function (response) {
					var reason = $(".aops-modal-wrapper")
						.find(".ebk-cancel-reason")
						.val();
					if (response) {
						onConfirmCancel(reason);
					}
				},
				{
					confirm_button_cancel: "Keep Online Book",
					confirm_button_ok: "Cancel Purchase",
					onShow: function () {
						$(".aops-modal-wrapper").find(".aops-modal-btn").eq(1).focus();
					},
				}
			);
		},

		onResetBook: function () {
			var confirmTpl = compileTemplate("#ebk-cms-reset-confirm");
			var doneTpl = compileTemplate("#ebk-cms-reset-done");
			var notDoneTpl = compileTemplate("#ebk-cms-reset-not-done");
			var model = this.model;
			var context = {
				title: model.get("title"),
			};

			function onConfirmReset(confirmString) {
				if (confirmString && confirmString === "RESET") {
					model.resetAllProblems(function (ok, data) {
						if (!ok) {
							EbkVBase.showModalError(
								"An error occurred when resetting all problems.",
								data
							);
						} else {
							var problems = model.get("problems");
							problems.each(function (problem) {
								problem.resetProblem();
							});
							Modal.showMessage(doneTpl(context));
						}
					});
				} else {
					Modal.closeTopModal();
					setTimeout(function () {
						Modal.showMessage(notDoneTpl(context));
					}, 0);
				}
			}

			Modal.showConfirm(
				confirmTpl(context),
				function (response) {
					var confirmString = $(".aops-modal-wrapper")
						.find(".ebk-reset-confirmation")
						.val();
					if (response) {
						onConfirmReset(confirmString);
					}
				},
				{
					confirm_button_cancel: "Cancel",
					confirm_button_ok: "Reset All Problems",
					onShow: function () {
						$(".aops-modal-wrapper").find(".aops-modal-btn").eq(1).focus();
					},
					title: "Are you sure?",
				}
			);
		},
	});

	EbkVIndex.BookChapter = EbkVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("ebk-tpl-index-book-chapter");

			this.render();
		},

		events: {
			"click a": "onClick",
		},

		getContext: function () {
			return {
				id: this.model.id,
				book_id: this.model.get("book").id,
				number: this.model.getTocNumber(),
				title: this.model.get("title_html"),
			};
		},

		onClick: function () {
			Backbone.trigger(
				"ebk_goto_section",
				this.model.get("book"),
				this.model.id
			);
		},
	});

	return EbkVIndex;
})(AoPS.Ebooks.Views.Index);
